import {
  Badge,
  Button,
  Col,
  Dropdown,
  Input,
  Modal,
  notification,
  Pagination,
  Popconfirm,
  Row,
  Spin,
  Tooltip,
  Upload,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { MdPersonAdd, MdDelete, MdEdit } from "react-icons/md";
import { BiChevronDown, BiFilterAlt } from "react-icons/bi";
import {
  DownloadOutlined,
  LoadingOutlined,
  UploadOutlined,
  WindowsFilled,
} from "@ant-design/icons";
import statusTemplate from "../../../Assets/Files/Sample_status_Change.xlsx";
import AddEmployee from "./AddEmployee";
import {
  ApiChangeStatus,
  BulkStatusApi,
  DeleteEmployeeApi,
  GenerateDocsAPI,
  GetAllEmployeesApi,
  GetEmpIdCardApi,
} from "../../../Services/EmployeeManager";
import { useLocation, useNavigate } from "react-router-dom";
import { GoLinkExternal } from "react-icons/go";
import { FaIdCard } from "react-icons/fa";
import {
  downloadBlob,
  downloadBlobHtml,
} from "../../../Services/GeneralFunctions";
import IdCard from "./IdCard";
import IconSlider from "./Slider";
import { IoMdEye } from "react-icons/io";
import TextArea from "antd/es/input/TextArea";

const { Search } = Input;

export default function EmployeesManager({ pageType }) {
  const [api, contextHolder] = notification.useNotification();
  const location = useLocation();

  const initialRender = useRef(true);
  const navigate = useNavigate();

  const [employeesData, setEmployeesData] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(10);

  const [isActiveFilter, setIsActiveFilter] = useState("");
  const [employeeIdFilter, setEmployeeIdFilter] = useState("");
  const [employeeNameFilter, setEmployeeNameFilter] = useState("");

  useEffect(() => {
    nofilterData();
  }, [pageType]);
  // const [ exportData, setExportData ] = useState(false);

  const [tableLoader, setTableLoader] = useState(false);

  const nofilterData = async () => {
    setEmployeesData(null);

    try {
      setTableLoader(true);
      const data = await GetAllEmployeesApi(
        page,
        "",
        "",
        "",
        "",
        pageType == "employees-verification" ? "new" : "existing"
      );
      setTableLoader(false);

      if (data.data.success) {
        setEmployeesData(data?.data?.data?.data);
        setTotal(data.data.data.page_count * 10);
      } else {
        api.error({
          message: "Error while fetching Employees List",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const generateDocuments = async (empID) => {
    try {
      const data = await GenerateDocsAPI(empID);
      console.log(data);
      if (data.data.success) {
        api.error({
          message: "Successfully Generated e-record",
          description: data.data.message,
          placement: "top",
        });
      } else {
        api.error({
          message: "Error while generating e-record",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const idNameFilteredData = async (exportData) => {
    setEmployeesData(null);
    try {
      setTableLoader(true);
      const data = await GetAllEmployeesApi(
        page,
        "",
        employeeIdFilter,
        employeeNameFilter,
        exportData,
        pageType == "employees-verification" ? "new" : "existing"
      );
      setTableLoader(false);

      if (data.data.success) {
        setEmployeesData(data.data.data.data);
        setTotal(data.data.data.page_count * 10);
      } else {
        if (data) {
          downloadBlob(data.data);
        } else {
          api.error({
            message: "Error while fetching Employees List",
            description: data.data.message,
            placement: "top",
          });
        }
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const isActiveFilteredData = async () => {
    setEmployeesData(null);
    try {
      setTableLoader(true);
      const data = await GetAllEmployeesApi(
        page,
        isActiveFilter,
        "",
        "",
        "",
        pageType == "employees-verification" ? "new" : "existing"
      );
      setTableLoader(false);

      if (data.data.success) {
        setEmployeesData(data.data.data.data);
        setTotal(data.data.data.page_count * 10);
      } else {
        api.error({
          message: "Error while fetching Employees List",
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      setTableLoader(false);
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const handleDelete = async (id, eCode) => {
    try {
      const data = await DeleteEmployeeApi(id);

      if (data.data.success) {
        nofilterData();
        api.success({
          message: `Employee (${eCode}) deleted successfully.`,
          placement: "top",
        });
      } else {
        api.error({
          message: `Error while Deleting Employee (${eCode})`,
          description: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const onClick = ({ key }) => {
    console.log(key);
    setEmployeeIdFilter("");
    setEmployeeNameFilter("");
    setIsActiveFilter(key);
  };

  const onSearch = () => {
    console.log(isActiveFilter);
    if (isActiveFilter !== null) {
      setIsActiveFilter(null);
    } else {
      idNameFilteredData();
    }
  };

  useEffect(() => {
    if (!initialRender.current) {
      if (page !== 1) {
        setPage(1);
      } else if (isActiveFilter !== null) {
        isActiveFilteredData();
      } else {
        idNameFilteredData();
      }
    }
  }, [isActiveFilter]);

  useEffect(() => {
    initialRender.current = false;
    if (isActiveFilter !== null) {
      isActiveFilteredData();
      setEmployeeIdFilter("");
      setEmployeeNameFilter("");
    } else {
      idNameFilteredData();
    }
  }, [page]);

  const items = [
    { label: "Yes", key: true },
    { label: "No", key: false },
    { label: "All of the above", key: "" },
  ];

  const [isModalOpen, setIsModalOpen] = useState({ bool: false, item: null });

  const showModal = (item) => {
    setIsModalOpen({ bool: true, item: item });
  };
  const handleOk = async () => {
    const { data } = await GetEmpIdCardApi(isModalOpen?.item?.employee_id);
    downloadBlobHtml(data?.data, `${isModalOpen?.item?.employee_id} ID Card`);
    // window.print();
    // setIsModalOpen({ bool: false, item: null });
  };
  const handleCancel = () => {
    setIsModalOpen({ bool: false, item: null });
  };

  const handleBulkUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    console.log("in", file);

    try {
      const data = await BulkStatusApi(formData);
      console.log(data);
      if (data?.data?.success) {
        api.success({
          message: "File is Submitted Successfully!",
          placement: "top",
        });
        nofilterData();
      } else {
        api.error({
          message: data?.data?.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error("Failed to update bulk status.");
    }

    return false;
  };

  console.log(employeesData, "checkinhg employee data");
  const getStatusStyles = (status) => {
    switch (status.toLowerCase()) {
      case "not verified":
        return { color: "#A0A0A0", backgroundColor: "#E2E2E2" };
      case "initiated":
        return { color: "#2196F3", backgroundColor: "#E0F1FF" };
      case "shortlisted":
        return { color: "#00BCD4", backgroundColor: "#D8FBFF" };
      case "rejected":
        return { color: "#FF0505", backgroundColor: "#FFDFDF" };
      case "onboarded":
        return { color: "#4CAF50", backgroundColor: "#E8FFE9" };
      default:
        return { color: "#000", backgroundColor: "#f0f0f0" };
    }
  };

  const StatusBadge = ({ status }) => {
    const styles = getStatusStyles(status);

    return (
      <div
        style={{
          ...styles,

          border: `1px solid ${styles.color}`,
          display: "inline-block",
        }}
        className="cursor-pointer d-flex align-items-center gap-0"
      >
        <span className="px-1 py-0 rounded-sm">{status}</span>

        <BiChevronDown />
      </div>
    );
  };

  return (
    <>
      {contextHolder}
      {/* <Modal
        title={isModalOpen?.item?.employee_id}
        okText="Download"
        open={isModalOpen?.bool}
        onOk={handleOk}
        onCancel={handleCancel}
        width={"600px"}
      >
        <IdCard item={isModalOpen?.item}></IdCard>
      </Modal> */}

      {/* <UpdateEmployee open={updateEmployeeToggle} onClose={() => setUpdateEmployeeToggle(false)} defaultValues={defaultValues} getEmployeesData={getEmployeesData} /> */}

      <section className="bg-white p-4 shadow-sm border border-gray-200 w-full rounded-2xl flex justify-between mb-2">
        <h2 className="text-2xl font-semibold text-gray-800">
          {pageType === "employees-verification"
            ? "Employees Verification"
            : "Employess Master"}
        </h2>

        <div
          className="w-fit px-4 py-2 rounded-md text-white bg-[#009BDE] hover:bg-[#009BDE] shadow-md hover:-translate-y-1 transition-all duration-300 flex items-center justify-center cursor-pointer"
          onClick={() =>
            navigate("/admin/add-emp", {
              state: {
                type:
                  pageType === "employees-verification" ? "new" : "existing",
              },
            })
          }
        >
          <MdPersonAdd className="text-lg font-bold mr-2" />
          <span className="font-semibold">Add Employee</span>
        </div>
      </section>
      <section className="bg-white p-4 pt-2 shadow-md border border-gray-900 w-full rounded-2xl mb-2">
        <Col className="mt-1 w-full">
          <div className="w-full flex justify-between">
            {/* <Col className="p-1" sm={8} xs={24}>
              <Search
                id="filterNew"
                value={employeeNewFilter}
                onChange={(e) => {
                  setEmployeeNewFilter(e.target.value);
                  setEmployeeNameFilter("");
                  setEmployeeIdFilter("");
                }}
                onSearch={onSearch}
                className="responsive-search"
                placeholder="Search New/Existing"
              />
            </Col> */}
            <Col className="flex gap-2" xs={24} sm={8}>
              <Search
                id="filterId"
                value={employeeIdFilter}
                onChange={(e) => {
                  setEmployeeIdFilter(e.target.value);
                  setEmployeeNameFilter("");

                  // setEmployeeNewFilter("");
                }}
                onSearch={onSearch}
                className="responsive-search"
                placeholder="Search Employee ID"
              />

              <Search
                id="filterName"
                value={employeeNameFilter}
                onChange={(e) => {
                  setEmployeeNameFilter(e.target.value);
                  setEmployeeIdFilter("");
                  // setEmployeeNewFilter("");
                }}
                onSearch={onSearch}
                className="responsive-search"
                placeholder="Search Employee Name"
              />
            </Col>
            {pageType == "employees-verification" && (
              <Col className="p-1 flex justify-end gap-2">
                <a
                  href={statusTemplate}
                  download="sample_status_template"
                  className="w-fit px-4 py-2 rounded-md border-2 border-[#009BDE] text-[#009BDE] bg-white-600 hover:bg-white-700 shadow-md hover:-translate-y-1 transition-all duration-300 flex items-center justify-center cursor-pointer"
                >
                  <DownloadOutlined className="text-lg font-bold mr-2" />
                  <span className="font-semibold">Download Sample</span>
                </a>
                <Upload
                  beforeUpload={handleBulkUpload}
                  showUploadList={false}
                  accept=".xlsx,.xls"
                >
                  <div className="w-fit px-4 py-2 rounded-md text-white bg-[#009BDE] hover:bg-[#009BDE] shadow-md hover:-translate-y-1 transition-all duration-300 flex items-center justify-center cursor-pointer">
                    <UploadOutlined className="text-lg font-bold mr-2" />
                    <span className="font-semibold"> Bulk Status Update</span>
                  </div>
                </Upload>
              </Col>
            )}
          </div>
        </Col>
        <Col style={{ overflowX: "auto" }}>
          <table className="custom-table mt-2">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email ID</th>
                <th>Employee ID</th>
                <th>Mobile</th>
                {pageType === "employees-verification" && (
                  <th>Appointment Letter</th>
                )}
                <th>Designation</th>
                <th>Role</th>

                <th>Reporting Manager</th>
                <th>Company</th>
                <th>Status</th>

                <Dropdown menu={{ items, onClick }} trigger={["click"]}>
                  <th style={{ cursor: "pointer" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      Is Active <BiFilterAlt /> <BiChevronDown />
                    </div>
                  </th>
                </Dropdown>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {employeesData &&
                employeesData.map((val) => (
                  <tr>
                    <td>{val.name.full_name}</td>
                    <td>
                      <div className="text-start d-flex justify-content-center">
                        {val.email.company}
                      </div>
                    </td>
                    <td>{val.employee_id}</td>
                    <td>{val.mobile}</td>
                    {pageType === "employees-verification" && (
                      <td>
                        {val?.offer_status?.status === true
                          ? "Accepted"
                          : val?.offer_status?.status === false
                          ? `Rejected-${val?.offer_status?.reason}`
                          : ""}
                      </td>
                    )}

                    <td>{val.designation}</td>
                    <td>{val.role}</td>

                    <td>{val?.reporting_manager?.name?.full_name}</td>
                    <td>{val?.company}</td>
                    <td
                      style={{
                        borderBottom: "none",
                        borderLeft: "none",
                        borderRight: "none",
                      }}
                      className="flex  justify-center pt-3 w-full h-full"
                    >
                      {pageType === "employees-verification" ? (
                        <Dropdown
                          className="border-none"
                          menu={{
                            items: [
                              { label: "Initiated", key: "Initiated" },
                              { label: "Shortlisted", key: "Shortlisted" },
                              { label: "Rejected", key: "Rejected" },
                              { label: "Onboarded", key: "Onboarded" },
                            ],
                            onClick: ({ key }) => {
                              if (key === "Rejected") {
                                Modal.confirm({
                                  icon: null,
                                  title: (
                                    <span style={{ color: "red" }}>
                                      Please enter reason for rejection:
                                    </span>
                                  ),
                                  content: (
                                    <TextArea
                                      autoSize={{ minRows: 3, maxRows: 6 }}
                                      placeholder="Write here..."
                                      onChange={(e) =>
                                        (window.rejectionReason =
                                          e.target.value)
                                      }
                                    />
                                  ),
                                  okText: "Submit",
                                  cancelText: "Cancel",
                                  onOk: async () => {
                                    if (
                                      !window.rejectionReason ||
                                      window.rejectionReason.trim() === ""
                                    ) {
                                      api.error({
                                        message:
                                          "Please enter a reason before submitting.",
                                        placement: "top",
                                      });
                                      throw new Error("Reason not provided"); // Prevent modal from closing
                                    }

                                    try {
                                      console.log(val);
                                      const res = await ApiChangeStatus(
                                        val?._id,
                                        key,
                                        window.rejectionReason.trim()
                                      );
                                      if (res?.data?.success) {
                                        api.success({
                                          message: res?.data?.message,
                                          placement: "top",
                                        });
                                        nofilterData();
                                      } else {
                                        api.error({
                                          message: res?.data?.message,
                                          placement: "top",
                                        });
                                      }
                                    } catch (err) {
                                      api.error({
                                        message: "Failed to update status.",
                                        placement: "top",
                                      });
                                    } finally {
                                      window.rejectionReason = "";
                                    }
                                  },
                                  onCancel: () => {
                                    window.rejectionReason = "";
                                  },
                                });
                              } else if (
                                key === "Onboarded" &&
                                !val?.employee_id
                              ) {
                                let enteredEmpId = "";
                                let enteredCompanyEmail = "";

                                Modal.confirm({
                                  icon: null,

                                  title: "Please provide below details",
                                  content: (
                                    <div>
                                      <Input
                                        placeholder="Enter Employee ID"
                                        className="mb-2"
                                        onChange={(e) =>
                                          (enteredEmpId = e.target.value)
                                        }
                                      />
                                      <Input
                                        placeholder="Enter Company Email"
                                        type="email"
                                        onChange={(e) =>
                                          (enteredCompanyEmail = e.target.value)
                                        } // <--
                                      />
                                    </div>
                                  ),
                                  okText: "Submit",
                                  cancelText: "Cancel",
                                  onOk: async () => {
                                    if (
                                      !enteredEmpId?.trim() ||
                                      !enteredCompanyEmail?.trim()
                                    ) {
                                      api.error({
                                        message:
                                          "Please enter both Employee ID and Company Email.",
                                        placement: "top",
                                      });
                                      throw new Error(
                                        "Required fields not provided"
                                      ); // Prevent modal from closing
                                    }

                                    try {
                                      const res = await ApiChangeStatus(
                                        val?._id,
                                        key,
                                        "",
                                        enteredEmpId,
                                        enteredCompanyEmail
                                      );
                                      if (res?.data?.success) {
                                        api.success({
                                          message: res?.data?.message,
                                          placement: "top",
                                        });
                                        generateDocuments(enteredEmpId);
                                        nofilterData();
                                      } else {
                                        api.error({
                                          message: res?.data?.message,
                                          placement: "top",
                                        });
                                      }
                                    } catch (err) {
                                      api.error({
                                        message: "Failed to update status.",
                                        placement: "top",
                                      });
                                    }
                                  },
                                });
                              } else {
                                Modal.confirm({
                                  title: `Confirm change status to ${key}?`,
                                  okText: "Yes",
                                  cancelText: "No",
                                  onOk: async () => {
                                    try {
                                      console.log(val);

                                      const res = await ApiChangeStatus(
                                        val?._id,
                                        key
                                      );
                                      if (res?.data?.success) {
                                        api.success({
                                          message: res?.data?.message,
                                          placement: "top",
                                        });
                                        nofilterData();
                                      } else {
                                        api.error({
                                          message: res?.data?.message,
                                          placement: "top",
                                        });
                                      }
                                    } catch (err) {
                                      api.error({
                                        message: "Failed to update status.",
                                        placement: "top",
                                      });
                                    }
                                  },
                                });
                              }
                            },
                          }}
                          trigger={["click"]}
                        >
                          <div className="cursor-pointer d-flex align-items-center gap-1">
                            <StatusBadge status={val?.overall_status || ""} />

                            {/* <BiChevronDown /> */}
                          </div>
                        </Dropdown>
                      ) : (
                        <div className="cursor-pointer d-flex align-items-center gap-1">
                          <div
                            style={{
                              color: "#4CAF50",
                              backgroundColor: "#E8FFE9",

                              border: `1px solid #4CAF50`,
                              display: "inline-block",
                            }}
                            className="cursor-pointer d-flex align-items-center gap-0"
                          >
                            <span className="px-1 py-0 rounded-sm">
                              {val?.overall_status || ""}
                            </span>
                          </div>
                        </div>
                      )}
                    </td>

                    <td>
                      {val.is_active ? (
                        <Badge status="success" text="Yes" />
                      ) : (
                        <Badge status="error" text="No" />
                      )}
                    </td>
                    <td>
                      <Row className="justify-content-center flex-nowrap">
                        <div
                          className="action-button mx-2 bg-light bg-gradient"
                          onClick={() => {
                            if (pageType == "employees-verification") {
                              navigate(
                                `/admin/employees-verification/edit/${val._id}`
                              );
                            } else {
                              navigate(`/admin/employees-manager/${val._id}`);
                            }
                          }}
                        >
                          <MdEdit className="text-dark fs-5" />
                        </div>
                        {/* <Tooltip
                        placement="top"
                        title={"ID Card Generator"}
                        color={"rgb(0, 155, 222, 1)"}
                      >
                        <div
                          className="action-button mx-2 bg-light bg-gradient"
                          onClick={() => {
                            showModal(val);
                          }}
                        >
                          <FaIdCard className="text-dark fs-5" />
                        </div>
                      </Tooltip> */}
                        {pageType == "employees-verification" && (
                          <div
                            className="action-button mx-2 bg-light bg-gradient"
                            onClick={() => {
                              navigate(
                                `/admin/employees-verification/${val._id}`
                              );
                            }}
                          >
                            <IoMdEye className="text-dark fs-5" />
                          </div>
                        )}
                        <Popconfirm
                          title={`Are you sure to delete Employee (${val.employee_id})?`}
                          onConfirm={() =>
                            handleDelete(val._id, val.employee_id)
                          }
                          okText="Yes"
                          cancelText="No"
                        >
                          <div className="action-button mx-2 bg-danger bg-gradient">
                            <MdDelete className="fs-5" />
                          </div>
                        </Popconfirm>
                      </Row>
                    </td>
                  </tr>
                ))}
            </tbody>
            <tfoot></tfoot>
          </table>
          {tableLoader && (
            <Row className="justify-content-center py-3">
              <Spin
                size="large"
                indicator={<LoadingOutlined className="text-light" />}
                spinning={true}
              />
            </Row>
          )}
        </Col>
      </section>

      {total > 10 && (
        <div className="round-edges bg-light py-2 my-2 text-center">
          <Pagination
            current={page}
            onChange={(val) => setPage(val)}
            total={total}
            hideOnSinglePage
          />
        </div>
      )}
    </>
  );
}
